import ReactGA from "react-ga4";

function sendEvent(...args:any) {
    ReactGA.event(...args);
    console.log(args);
}

/*
|--------------------------------------------------------------------------
| Objects
|--------------------------------------------------------------------------
*/
function objectCreated({type}) {
    sendEvent({
        category: "actions",
        action: type+"_created",
    });
}

function objectEdited({type}) {
    sendEvent({
        category: "actions",
        action: type+"_edited",
    });
}

function objectDeleted({type}) {
    sendEvent({
        category: "actions",
        action: type+"_deleted",
    });
}

function objectRestored({type}) {
    sendEvent({
        category: "actions",
        action: type+"_restored",
    });
}

/*
|--------------------------------------------------------------------------
| Files
|--------------------------------------------------------------------------
*/
function fileUploaded(/*{ size = null, extension = null }*/) {
    sendEvent({
        category: "actions",
        action: "file_uploaded",
    });
}

function fileDeleted() {
    sendEvent({
        category: "actions",
        action: "file_deleted",
    });
}

/*
|--------------------------------------------------------------------------
| Tools
|--------------------------------------------------------------------------
*/
function volunteerHoursBulkAdded() {
    sendEvent({
        category: "actions",
        action: "volunteer_hour_bulk_added",
    });
}

function rapidReinvestmentUsed() {
    sendEvent({
        category: "actions",
        action: "rapid_reinvestment_used",
    });
}

/*
|--------------------------------------------------------------------------
| Data / Reports
|--------------------------------------------------------------------------
*/
function dataImported() {
    sendEvent({
        category: "actions",
        action: "data_imported",
    });
}

function reportRan() {
    sendEvent({
        category: "actions",
        action: "report_ran",
    });
}

/*
|--------------------------------------------------------------------------
| Outward facing
|--------------------------------------------------------------------------
*/
function volunteerSignedUp() {
    sendEvent({
        category: "actions",
        action: "volunteer_signed_up",
    });
}


/*
|--------------------------------------------------------------------------
| Exports
|--------------------------------------------------------------------------
*/

const events = {
    objectCreated,
    objectEdited,
    objectDeleted,
    objectRestored,

    fileUploaded,
    fileDeleted,

    volunteerHoursBulkAdded,
    rapidReinvestmentUsed,

    dataImported,
    reportRan,

    volunteerSignedUp,
};

export {events};
